<template>
  <span class="url-animated-placeholder" aria-hidden="true">{{ displayedText }}</span>
</template>

<script>
const EXAMPLE_URLS = [
  "https://www.youtube.com/watch?v=VIDEO_ID",
  "https://kick.com/channel/videos/12345678",
  "https://www.twitch.tv/videos/123456789",
  "https://www.facebook.com/page/videos/123456789/",
  "https://drive.google.com/file/d/FILE_ID/view",
];

const TYPE_DELAY_MS = 28;
const DELETE_DELAY_MS = 24;
const HOLD_DELAY_MS = 1100;
const SWITCH_DELAY_MS = 280;

export default {
  name: "MakeClipsAnimatedUrlPlaceholder",
  data() {
    return {
      displayedText: "",
      exampleIndex: 0,
      charIndex: 0,
      isDeleting: false,
      timerId: null,
    };
  },
  mounted() {
    this.scheduleTick(0);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timerId == null) return;
      clearTimeout(this.timerId);
      this.timerId = null;
    },
    scheduleTick(delayMs) {
      this.clearTimer();
      this.timerId = setTimeout(this.tick, delayMs);
    },
    tick() {
      const fullText = EXAMPLE_URLS[this.exampleIndex];

      if (!this.isDeleting) {
        if (this.charIndex < fullText.length) {
          this.charIndex += 1;
          this.displayedText = fullText.slice(0, this.charIndex);
          this.scheduleTick(TYPE_DELAY_MS);
          return;
        }

        this.scheduleTick(HOLD_DELAY_MS);
        this.isDeleting = true;
        return;
      }

      if (this.charIndex > 0) {
        this.charIndex -= 1;
        this.displayedText = fullText.slice(0, this.charIndex);
        this.scheduleTick(DELETE_DELAY_MS);
        return;
      }

      this.isDeleting = false;
      this.exampleIndex = (this.exampleIndex + 1) % EXAMPLE_URLS.length;
      this.scheduleTick(SWITCH_DELAY_MS);
    },
  },
};
</script>

<style scoped>
.url-animated-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding: 16px 18px;
  font-size: 12px;
  color: var(--clipr-text-tertiary, #64748b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  user-select: none;
}
</style>
